import config from 'config';
import { http_client } from './api';

const getList = async (query) => {
  return http_client.get(config.apiUrl + 'examscore', query).then((response) => {
    return response.data;
  });
};

const getListArchive = async (query) => {
  return http_client.get(config.apiUrl + 'examscore', query).then((response) => {
    return response.data;
  });
};

const create = async (data) => {
  return http_client.post(config.apiUrl + 'examscore', data).then((response) => {
    return response.data;
  });
};
const read = async (id) => {
  return http_client.get(config.apiUrl + 'examscore/' + id).then((response) => {
    return response.data;
  });
};
const update = async (id, data) => {
  return http_client.patch(config.apiUrl + 'examscore/' + id, data).then((response) => {
    return response.data;
  });
};
const del = async (id) => {
  return await http_client.delete(config.apiUrl + 'examscore/' + id).then((response) => {
    return response.data;
  });
};
const changeStatus = async (id, data) => {
  return http_client.post(config.apiUrl + 'examscore/' + id + '/status', data).then((response) => {
    return response.data;
  });
};
const ExamScoreService = {
  getList,
  getListArchive,
  create,
  read,
  update,
  del,
  changeStatus
};

export default ExamScoreService;
